import React from 'react';
import { FormPart, part } from '~/lib/FormCssApi';

/**
 * Shared by the attendee count on a scheduling question and the quantity on an
 *  add-on, so the hooks below reach both. To style only one of them, name the
 *  question type or the block it sits in.
 */
const Stepper = ({ value, onChange, className, renderValue, maxValue }) => {
    const isAtMax = maxValue && value >= maxValue;

    return (
        <div
            {...part(FormPart.STEPPER)}
            className={`flex w-fit items-center border bg-primary-100 rounded-full text-center select-none btn-inverse ${className}`}
        >
            <div
                {...part(FormPart.STEPPER_DECREASE)}
                className="px-4 py-1.5 cursor-pointer rounded-l-full"
                onClick={() => onChange(value - 1)}
            >
                -
            </div>
            <div
                {...part(FormPart.STEPPER_VALUE)}
                className="px-2 py-1.5 min-w-8 text-black"
            >
                {typeof renderValue === 'function' ? renderValue(value) : value}
            </div>
            <div
                {...part(FormPart.STEPPER_INCREASE)}
                className={`px-4 py-1.5 rounded-r-full ${isAtMax ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={() => !isAtMax && onChange(value + 1)}
            >
                +
            </div>
        </div>
    );
};

export default Stepper;
